module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-gatsby-cloud/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Tiny Battle Royale","short_name":"Tiny Battle","description":"L'application de simulation de Battle Royale.","lang":"fr","start_url":"/","background_color":"#F27D16","theme_color":"#F27D16","display":"fullscreen","icon":"src/images/favicons/favicon.png","icons":[{"src":"src/images/favicons/favicon_512x512.png","sizes":"512x512","type":"image/png"},{"src":"src/images/favicons/favicon_192x192.png","sizes":"192x192","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6b8f33fc10a19888c6b38fbae6e73ae2"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
